"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelById = void 0;
const getHotelById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("hotels")
        .select("*")
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getHotelById = getHotelById;
